<div class="drawer-container has-pos-rel" [ngClass]="ListingCategory[currentShownListingType]">
  <header class="has-pos-rel has-padding">
    <div class="top-level">
      <h3 class="drawer-title text-center">
        {{ title }}
        <i class="material-icons v-align pull-right" *ngIf="enableCloseButton" (click)="closed.emit()">close</i>
      </h3>
    </div>
    <div class="sub-level">
      <div class="is-flex drawer-sub-title-left" *ngIf="enableApplyButton" (click)="closed.emit()">
        <div class="back is-flex has-flex-content-center has-flex-align-center" style="margin-right: 5px;">
          <svg width="16px" height="13px" viewBox="0 0 16 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="DESKTOP-LUX-LDP" fill="none" fill-rule="evenodd">
              <g id="Artboard" transform="translate(-14 -161)" fill="#004E9B">
                <g id="Back-to-search" transform="translate(6.7148 154.28)">
                  <g id="Back-btn" transform="translate(2)">
                    <g id="ARROW" transform="translate(13.375 13.5) rotate(90) translate(-6.5 -8)">
                      <path d="m11.66 14.262h-10.5c-0.31088 0-0.5625 0.252-0.5625 0.5625 0 0.31088 0.25162 0.5625 0.5625 0.5625h10.5c0.31088 0 0.5625-0.25162 0.5625-0.5625 0-0.3105-0.25162-0.5625-0.5625-0.5625"/>
                      <path d="m5.9607 12.581c0.10538 0.10688 0.249 0.16762 0.399 0.16838s0.29438-0.0585 0.4005-0.16462l4.7344-4.7344c0.10988-0.10988 0.16462-0.25388 0.16462-0.39788s-0.05475-0.288-0.16462-0.39788c-0.21975-0.21938-0.576-0.21938-0.79538 0l-3.7628 3.7628v-10.154c0-0.31088-0.252-0.5625-0.5625-0.5625-0.31088 0-0.5625 0.25162-0.5625 0.5625v10.159l-3.6862-3.756c-0.21788-0.222-0.57375-0.225-0.79575-0.0075-0.22162 0.21788-0.22462 0.57412-0.0075 0.79538l4.6388 4.7269"/>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
        {{ 'filters.apply' | translate }}
      </div>
      <span class="drawer-sub-title-right"></span>
    </div>
  </header>
  <hr style="margin: 0;">
  <section class="has-padding">
    <ng-content></ng-content>
  </section>
</div>
